/** @jsx jsx */
import { jsx } from "theme-ui";
import getMandatoryEnv from "sites-common/utils/getMandatoryEnv";
import { useCallback, useEffect, useRef } from "react";
import { useDispatch } from "react-redux";
import {
  setUserToken,
  unsetUser,
} from "gatsby-plugin-hfn-profile/state/actions";
import logOut from "gatsby-plugin-hfn-profile/lib/auth";

const { keycloakConfig } = getMandatoryEnv(["keycloakConfig"]);
const Auth = () => {
  const path = typeof window !== "undefined" ? window.location.pathname : "";
  const elementRef = useRef(null);
  const dispatch = useDispatch();
  useEffect(() => {
    import("hfn-oneauth/main");
  }, []);

  const updateToken = useCallback(async () => {
    const authData =
      typeof window !== "undefined" ? localStorage.getItem("pstate") : "";
    const newAuthData = authData ? JSON.parse(authData) : "";
    if (!newAuthData?.srcmtoken?.token) {
      return false;
    }
    if (typeof window !== "undefined") {
      const { getRefreshToken } = await import("hfn-oneauth/main");
      await getRefreshToken(keycloakConfig)
        .then(async (res) => {
          if (res?.data?.access_token) {
            dispatch(
              setUserToken({
                ...newAuthData?.srcmtoken,
                token: res?.data?.access_token,
              })
            );
          } else if (await logOut()) {
            dispatch(unsetUser());
          }
        })
        .catch(() => {
          // //console.log(e);
        });
    }
    return true;
  }, [dispatch]);

  useEffect(() => {
    updateToken();
  }, [updateToken]);

  const handleUserLoggedOut = async (event) => {
    if (event?.detail?.loggedOut && (await logOut())) {
      dispatch(unsetUser());
    }
  };
  useEffect(() => {
    elementRef.current = document.querySelector("hfn-oneauth");
    const listener = (event) => handleUserLoggedOut(event);
    // Add the event listener when the element is present
    if (elementRef.current) {
      elementRef.current.addEventListener("userLoggedOut", listener);
    }
    //  Cleanup event listener on unmount or when path changes
    return () => {
      if (elementRef.current) {
        elementRef?.current?.removeEventListener("userLoggedOut", listener);
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [elementRef]);
  return (
    <hfn-oneauth
      ref={elementRef}
      config={JSON.stringify(keycloakConfig)}
      showCancel="true"
      authType={
        path && path?.startsWith("/oneauth/authorization") ? "" : "on-demand"
      }
    />
  );
};

export default Auth;
